import { ExtensionFrame } from "@/features/extensions/ExtensionFrame";
import { useSession } from "@/lib/session";
import { ExtensionV2CostingReview } from "./ExtensionV2CostingReview";

export interface ExtensionCostingReviewProps {
  context: { license_id: string; period: { start: string; end: string } };
  installationId?: string;
  viewId?: string;
  dependencyInstallationId: string | null;
  disabled: boolean;
  reviewedInputs?: Record<string, unknown> | null;
  onReviewed: (inputs: Record<string, unknown> | null) => void | Promise<void>;
}

export function ExtensionCostingReview(props: ExtensionCostingReviewProps) {
  const {
    context,
    installationId,
    viewId,
    dependencyInstallationId,
    disabled,
    reviewedInputs,
    onReviewed,
  } = props;
  const { state: session } = useSession();
  const actorRef = session.status === "authenticated" ? session.user.id : undefined;
  if (installationId && viewId) {
    return (
      <ExtensionV2CostingReview
        installationId={installationId}
        viewId={viewId}
        context={context}
        dependencyInstallationId={dependencyInstallationId}
        disabled={disabled}
        onReviewed={onReviewed}
      />
    );
  }
  const reviewInputs = reviewedInputs && typeof reviewedInputs.review_inputs === "object" && reviewedInputs.review_inputs !== null
    ? reviewedInputs.review_inputs as Record<string, unknown>
    : null;
  const reviewedExciseReview = reviewInputs?.excise_review;
  return (
    <ExtensionFrame
      publisher="sylviq"
      extensionKey="niche-cultivation-costing"
      className="min-h-[42rem] w-full rounded-xl border border-[var(--border)] bg-[var(--surface)]"
      reviewedExciseReview={reviewedExciseReview}
      mode={{
        close: {
          license_id: context.license_id,
          period: { ...context.period },
          dependency_installation_id: dependencyInstallationId ?? undefined,
          ...(actorRef ? { actor_ref: actorRef } : {}),
          disabled,
        },
      }}
      onReviewed={(inputs) => onReviewed(inputs as Record<string, unknown>)}
    />
  );
}
